import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './styles/main.scss';

import { getMomentLocale } from '@helpers/locale';
import SubmitButton from '@components/asset/modal/tabs/workflow/attachment_details/checkin_checkout/submit_button';

const CheckInCheckOut = ({
  activeAttachment,
  activeAttachmentReservations,
  asset,
  initializeTab,
  setAttachmentReservations,
  setShowCheckinCheckout,
  setVersionsActionLoading,
  showCheckinCheckout,
  versionCard,
  updateFetchControllers,
}) => {
  const [textareaValue, setTextareaValue] = useState('');

  const { filename } = versionCard.version_details;
  const checkedInStatus = activeAttachmentReservations.currentStatus;

  const handleClose = () => {
    setShowCheckinCheckout(false);
    setTextareaValue('');
    setVersionsActionLoading(false);
  };

  const displayCheckoutContent = () => (
    <>
      <h3 className="title">
        {t('Check Out')}
        <span className="filename">{filename}</span>
      </h3>
      <p className="copy">{t('To update or make edits to this attachment outside of Brandfolder, download it via the "Check Out" button below.')}</p>
      <h4 className="textarea-title">{t('(Optional) Why are you checking out this attachment?')}</h4>
    </>
  );

  const displayCheckinContent = () => {
    const reservationsSorted = [...activeAttachmentReservations.history].sort((a, b) => (
      new Date(b.created_at) - new Date(a.created_at)
    ));
    const latestReservation = reservationsSorted[0];
    const latestAuthor = latestReservation.author;
    const latestUpdate = latestReservation.created_at;
    const latestEmail = activeAttachmentReservations.users[latestAuthor].email;
    const isLatestUser = BFG.currentUser.user_id === latestAuthor;

    return (
      <>
        <h3 className="title">
          {t('Check In')}
          <span className="filename">{filename}</span>
        </h3>
        {isLatestUser ? (
          <>
            <p className="copy">{`You checked this attachment out ${moment(latestUpdate).locale(getMomentLocale()).fromNow()}.`}</p>
            <p className="copy">{t('To check this attachment back in to Brandfolder, upload it via the “Check In” button below.')}</p>
          </>
        ) : (
          <>
            <p className="copy">
              <a href={`mailto:${latestEmail}`}>{latestEmail}</a>
              {`checked this attachment out ${moment(latestUpdate).locale(getMomentLocale()).fromNow()}. Please follow up with them to retrieve the most current version.`}
            </p>
            <p className="copy">{t('If you’d like to check this attachment back in yourself, upload it via the “Check In” button below.')}</p>
          </>
        )}
        <h4 className="textarea-title">{t('(Optional) What changes have been made to this attachment?')}</h4>
      </>
    );
  };

  useEffect(() => (() => handleClose()), []);

  return (
    <div className={`checkin-checkout-wrapper ${showCheckinCheckout ? 'active' : ''}`}>
      {showCheckinCheckout && (
        <div className="checkin-checkout-container">
          <div className="button-container">
            <button
              className="go-back-button"
              onClick={handleClose}
              type="button"
            >
              <span className="bff-left-arrow icon" />
              {t('Back')}
            </button>
          </div>
          {checkedInStatus === 'checked_in'
            ? displayCheckoutContent()
            : displayCheckinContent()
          }
          <textarea
            className="bf-input message-textarea"
            onChange={(e) => setTextareaValue(e.target.value)}
            value={textareaValue}
          />
          <SubmitButton
            activeAttachment={activeAttachment}
            asset={asset}
            checkedInStatus={checkedInStatus}
            handleClose={handleClose}
            initializeTab={initializeTab}
            setAttachmentReservations={setAttachmentReservations}
            textareaValue={textareaValue}
            updateFetchControllers={updateFetchControllers}
            versionCard={versionCard}
          />
        </div>
      )}
    </div>
  );
};

CheckInCheckOut.propTypes = {
  activeAttachment: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  activeAttachmentReservations: PropTypes.shape({
    currentStatus: PropTypes.string,
    history: PropTypes.arrayOf(PropTypes.shape({})),
    users: PropTypes.shape({}),
  }).isRequired,
  asset: PropTypes.shape({
    asset_key: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  initializeTab: PropTypes.func.isRequired,
  setAttachmentReservations: PropTypes.func.isRequired,
  setShowCheckinCheckout: PropTypes.func.isRequired,
  setVersionsActionLoading: PropTypes.func.isRequired,
  showCheckinCheckout: PropTypes.bool.isRequired,
  updateFetchControllers: PropTypes.func.isRequired,
  versionCard: PropTypes.shape({
    version_details: PropTypes.shape({
      url: PropTypes.string,
      filename: PropTypes.string,
      metadata: PropTypes.shape({
        mime_type: PropTypes.string,
      }),
    })
  }).isRequired,
};

export default CheckInCheckOut;
